import { useState } from 'react';
import { Link } from 'react-router-dom';
import riwaazImage from '../../assets/images/events/riwaaz/x2.jpeg';
import trailerVideo from '../../assets/videos/homepage/homepage_video_1.mp4';
import './Events.css';

const Events = () => {
  const [showTrailer, setShowTrailer] = useState(false);

  return (
    <div className="events-page py-4">
      <div className="container py-3">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="banner-card overflow-hidden">
              {/* Large logo in the starting */}
              <div className="text-center p-4 pb-0">
                <img
                  src={riwaazImage}
                  alt="HOUSE X²"
                  className="img-fluid banner-image"
                />
              </div>

              <div className="card-body p-4 p-lg-4 text-white">
                <div className="text-center mb-4">
                  <span className="badge event-badge px-3 py-2 rounded-pill">
                    Event of the Month
                  </span>

                  <h2 className="display-6 fw-bold mt-3 mb-2">
                    HOUSE X²: OTT Reality Show
                  </h2>

                  <p className="lead text-warning fw-semibold mb-0">
                    One House. Infinite Challenges.
                  </p>
                </div>

                <div className="text-center d-flex flex-wrap justify-content-center gap-3 mb-5">
                  <button
                    type="button"
                    className="btn btn-register btn-lg px-5 py-3 rounded-pill fw-bold"
                    onClick={() => setShowTrailer(true)}
                  >
                    Watch Trailer
                  </button>
                  <Link
                    to="/registration"
                    className="btn btn-register btn-lg px-5 py-3 rounded-pill fw-bold"
                  >
                    Apply For Audition
                  </Link>
                </div>

                {/* About Show */}
                <div className="mb-5">
                  <h3 className="fw-bold text-warning text-center mb-4">
                    About Show
                  </h3>

                  <p className="text-white-50 fs-5">
                    House X² is a high-energy Reality Show where contestants live
                    together in a luxury villa while competing in exciting
                    physical, mental, social and entertainment based challenges.
                  </p>

                  <p className="text-white-50 fs-5">
                    Every day brings new alliances, betrayals, unexpected twists
                    and dramatic eliminations.
                  </p>

                  <p className="text-white-50 fs-5">
                    Unlike a traditional competition, contestants must balance
                    friendship, strategy and performance to survive until the
                    Finale.
                  </p>
                </div>

                {/* Show Format */}
                <div className="mb-5">
                  <h3 className="fw-bold text-warning text-center mb-4">
                    Show Format
                  </h3>

                  <p className="text-white-50 fs-5 text-center">
                    Contestant promo shoot will be done in Mumbai and Reality
                    Show shoot will be done in Goa.
                  </p>
                </div>

                {/* Contestant / Appearance */}
                <div className="mb-5">
                  <span className="badge event-badge px-3 py-2 rounded-pill d-block mx-auto mb-4" style={{ maxWidth: 'fit-content' }}>
                    Institution / Appearance of the Month
                  </span>

                  <div className="row g-4">
                    <div className="col-md-4">
                      <div className="info-box h-100 text-center p-4 rounded-4">
                        <div className="fs-1 mb-2">🎬</div>
                        <h6 className="fw-bold text-warning">Contestant</h6>
                        <p className="mb-1 text-white-50">Age: 18+</p>
                        <p className="mb-0 text-white-50">
                          Models, influencers, performers, entrepreneurs,
                          athletes and talented newcomers
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="info-box h-100 text-center p-4 rounded-4">
                        <div className="fs-1 mb-2">🗓️</div>
                        <h6 className="fw-bold text-warning">Shoot Duration</h6>
                        <p className="mb-1 text-white-50">8–10 Days</p>
                        <p className="mb-1 text-white-50">Daily episodes</p>
                        <p className="mb-0 text-white-50">Grand Finale with top 4</p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="info-box h-100 text-center p-4 rounded-4">
                        <div className="fs-1 mb-2">⏰</div>
                        <h6 className="fw-bold text-warning">Daily Structure</h6>
                        <p className="mb-0 text-white-50">
                          Morning, Afternoon, Evening &amp; Night activities
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Daily Structure detail */}
                <div className="mb-5">
                  <h3 className="fw-bold text-warning text-center mb-4">
                    Daily Structure
                  </h3>

                  <div className="row g-3">
                    {[
                      ['🌅 Morning', 'Wake up activity, fitness or fun challenge'],
                      ['☀️ Afternoon', 'Team task or individual challenge'],
                      ['🌆 Evening', 'House interactions, strategy, drama and entertainment'],
                      ['🌙 Night', 'Surprise twist, nominations or secret mission'],
                    ].map(([title, desc]) => (
                      <div className="col-md-6" key={title}>
                        <div className="highlight-box rounded-3 p-3 h-100">
                          <strong className="text-white">{title}:</strong>{' '}
                          {desc}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Day 1 */}
                <div className="mb-5">
                  <span className="badge event-badge px-3 py-2 rounded-pill d-block mx-auto mb-4" style={{ maxWidth: 'fit-content' }}>
                    01 Monday February
                  </span>

                  <h3 className="fw-bold text-warning text-center mb-4">
                    Type of Challenges
                  </h3>

                  <div className="row g-3 mb-5">
                    {[
                      'Adventure challenges',
                      'Puzzle and mind games',
                      'Team competitions',
                      'Trust challenges',
                      'Talent performances',
                      'Treasure hunts',
                      'Beach and water challenges',
                      'Mystery missions',
                      'Survival task',
                    ].map((item) => (
                      <div className="col-md-6" key={item}>
                        <div className="highlight-box rounded-3 p-3 h-100">
                          ✨ {item}
                        </div>
                      </div>
                    ))}
                  </div>

                  <h3 className="fw-bold text-warning text-center mb-4">
                    Daily Cycle Twist
                  </h3>

                  <p className="text-white-50 fs-5 text-center">
                    Every day the House X² changes the game. Examples include:
                  </p>

                  <div className="row g-3">
                    {[
                      'Contestants become captains',
                      'Teams are reshuffled',
                      'Double elimination',
                      'A previously eliminated contestant returns',
                      'Hidden advantages are placed inside the House',
                      'Daily twists that keep the competition fresh',
                    ].map((item) => (
                      <div className="col-md-6" key={item}>
                        <div className="highlight-box rounded-3 p-3 h-100">
                          🔀 {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Day 2 */}
                <div className="mb-5">
                  <span className="badge event-badge px-3 py-2 rounded-pill d-block mx-auto mb-4" style={{ maxWidth: 'fit-content' }}>
                    02 Tuesday February
                  </span>

                  <h3 className="fw-bold text-warning text-center mb-4">
                    Grand Finale
                  </h3>

                  <p className="text-white-50 fs-5 text-center">
                    The finalists complete a multi-stage final challenge testing
                    endurance, teamwork, problem solving and strategy. The
                    winner receives the House X² Trophy and an opportunity with
                    production partners.
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="/registration"
                    className="btn btn-register btn-lg px-5 py-3 rounded-pill fw-bold"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showTrailer && (
        <div
          className="trailer-modal-backdrop"
          onClick={() => setShowTrailer(false)}
        >
          <div
            className="trailer-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="trailer-modal-close"
              aria-label="Close trailer"
              onClick={() => setShowTrailer(false)}
            >
              &times;
            </button>
            <video
              src={trailerVideo}
              controls
              autoPlay
              className="trailer-modal-video"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;
